import { styled, IconButton, Box, Typography } from '@mui/material';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';

const RightNavGrow = styled(KeyboardArrowRight)(({ theme }) => ({
    '&:hover': {
        'animation': 'grow 200ms forwards',
    },
    '@keyframes grow': {
        'from': {
            transform: 'scale(1)',
        },
        'to': {
            transform: 'scale(1.3)',
        },
    },
}));

export const RightGrowNav = props => {
    return (
        <Box onClick={props.onClick}>
            {props.text && <Typography variant="body">{props.text}</Typography>}

            <IconButton>
                <RightNavGrow></RightNavGrow>
            </IconButton>
        </Box>
    );
};

export default RightGrowNav;
